import React from 'react';
import { APP_VERSION, APP_NAME } from '../config/version';
import './Footer.css';

const Footer = ({ className = "", centered = false }) => {
  const currentYear = new Date().getFullYear();

  if (centered) {
    return (
      <div className={`app-footer ${className}`}>
        <div className="footer-content-centered">
          <div className="footer-copyright-centered">
            {currentYear} Worldwide Holidays Ltd. All rights reserved. | Developed by <a href="https://freeai.co.nz" target="_blank" rel="noopener noreferrer">FREEAI</a>
          </div>
          <div className="footer-version-centered">
            {APP_NAME} V{APP_VERSION}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`app-footer ${className}`}>
      <div className="footer-content">
        <span className="footer-copyright">
          {currentYear} Worldwide Holidays Ltd. All rights reserved. | Developed by <a href="https://freeai.co.nz" target="_blank" rel="noopener noreferrer">FREEAI</a>
        </span>
        <span className="footer-version">
          {APP_NAME} V{APP_VERSION}
        </span>
      </div>
    </div>
  );
};

export default Footer;
